/* eslint-disable import/prefer-default-export */

import * as settings from '../settings';

export const ecomApiSettings = {
  countryName: settings.COUNTRY_NAME,
  countryCodeAlpha3: settings.COUNTRY_CODE_ALPHA3,
};
